import { SET_NUMBER_OF_PDF } from './types'

export default (state = { number: 0 }, action) => {
    switch (action.type) {
        case SET_NUMBER_OF_PDF:
            return { ...state, number: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/pdf/reducer.js